import axios from 'axios'
import sign from '@/assets/js/sign'

// 请求发起前拦截器
axios.interceptors.request.use(
  config => {
    // 拼接通用的参数
    // config.params = {
    //   'Ykt-Token': appInfo.token,
    //   ...config.params
    // }
    var signValues = sign(config)
    config.headers = {
      ...config.headers,
      ...signValues
    }
    return config
  },
  error => {
    // 异常处理
    return Promise.resolve({
      result: {
        code: -100,
        error
      }
    })
  }
)

// 响应拦截
axios.interceptors.response.use(
  ({ data }) => {
    // 这里返回的 response.data 是被 axios 包装过的一成，所以在这里抽取出来

    return data
  },
  error => {
    return Promise.resolve({
      result: {
        code: -100,
        error
      }
    })
  }
)

// 导出
export default axios
